import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { DEFAULT_PAGE_SIZE, AdsStudioSpinner } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { Layer, Overlay } from '@bingads-webui-react/fabric-control';
import { useLayoutStyles } from '../styles';

export const AssetDetailsPageLayout = ({
  navigation,
  navigateToOtherItem,
  // navigateToFallbackPage,
  itemId,
  loadedItems,
  loadMoreItemsAsync,
  renderItemPreview,
  renderItemDetails,
  // permissions,
  pageSize,
  reloadLandingPageRef,
  onClose,
}) => {
  const [hideContent] = useState(false);
  const [loadMoreFlag, setLoadMoreFlag] = useState(false);

  const currentIndex = useMemo(
    () => _.findIndex(loadedItems, item => item.id === itemId),
    [itemId, loadedItems]
  );

  const itemInfo = useMemo(
    () => _.find(loadedItems, item => item.id === itemId),
    [loadedItems, itemId]
  );

  const redirectToOtherItem = useCallback((index) => {
    const { id, folderAssetType } = loadedItems[index];
    navigateToOtherItem({ id, folderAssetType });
  }, [loadedItems, navigateToOtherItem]);

  // in case user refresh in detail page
  // useEffect(() => {
  //   if (!itemInfo) {
  //     if (permissions && permissions.dynamic.SmartMediaGenerationPrototype) {
  //       return;
  //     }
  //     navigateToFallbackPage();
  //   }
  // }, [itemInfo, navigateToFallbackPage, permissions]);

  useEffect(() => {
    if (loadMoreFlag && loadedItems[currentIndex + 1]) {
      setLoadMoreFlag(false);
      redirectToOtherItem(currentIndex + 1);
    }
  }, [currentIndex, loadMoreFlag, loadedItems, redirectToOtherItem]);

  const dismiss = useCallback(() => {
    if (onClose) {
      onClose();
    }
    navigation.goBack({ reload: reloadLandingPageRef.current });
  }, [navigation, onClose, reloadLandingPageRef]);

  const gotoNext = useCallback(() => {
    const nextIndex = currentIndex + 1;
    if (nextIndex >= _.size(loadedItems)) {
      setLoadMoreFlag(true);
      loadMoreItemsAsync({ count: pageSize || DEFAULT_PAGE_SIZE });
    } else {
      redirectToOtherItem(nextIndex);
    }
  }, [currentIndex, loadMoreItemsAsync, loadedItems, pageSize, redirectToOtherItem]);

  const gotoPrevious = useCallback(() => {
    const previousIndex = currentIndex - 1;
    redirectToOtherItem(previousIndex);
  }, [currentIndex, redirectToOtherItem]);

  const itemPreviewRef = useRef();

  const footerKeyDownHandler = useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();

    if (event.code === 'Tab' && itemPreviewRef && itemPreviewRef.current) {
      itemPreviewRef.current.focus();
    }
  }, []);

  const classes = useLayoutStyles();

  return (
    <Layer className={classnames(classes.layer, 'item-detail-page-root')}>
      <Overlay
        className={classnames(classes.overlay, 'item-detail-page')}
      >
        {itemInfo && !loadMoreFlag ? (
          <>
            <div className={classnames(classes.previewContainer, 'item-preview-container')} ref={itemPreviewRef} >
              {renderItemPreview({
                    itemData: itemInfo,
                    shouldHideContent: hideContent,
                    currentIndex,
                    gotoNext,
                    gotoPrevious,
                  })}
            </div>
            {renderItemDetails({
                  itemData: itemInfo,
                  dismiss,
                  footerKeyDownHandler,
                })}
          </>
              ) : (
                <AdsStudioSpinner />
              )
            }
      </Overlay>
    </Layer>
  );
};

AssetDetailsPageLayout.propTypes = {
  navigation: PropTypes.shape({
  }).isRequired,
  navigateToOtherItem: PropTypes.func.isRequired,
  // navigateToFallbackPage: PropTypes.func.isRequired,
  itemId: PropTypes.string.isRequired,
  loadedItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    folderAssetType: PropTypes.string.isRequired,
  })),
  loadMoreItemsAsync: PropTypes.func.isRequired,
  renderItemPreview: PropTypes.func.isRequired,
  renderItemDetails: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      SmartMediaGenerationPrototype: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  pageSize: PropTypes.number,
};

AssetDetailsPageLayout.defaultProps = {
  loadedItems: [],
  pageSize: DEFAULT_PAGE_SIZE,
};
